module.exports = __webpack_public_path__ + "static/media/workflow.f9d8d627.svg";